import { render, staticRenderFns } from "./Primary.vue?vue&type=template&id=674e8aa4&scoped=true&"
import script from "./Primary.vue?vue&type=script&lang=js&"
export * from "./Primary.vue?vue&type=script&lang=js&"
import style0 from "./Primary.vue?vue&type=style&index=0&id=674e8aa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674e8aa4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VContent,VNavigationDrawer,VRow})
